import { isFunction } from '@loadsmart/utils-function';

import type { LocationParser, Location } from './location-select.types';

type ParsedLocation = { lat: number; lng: number };

export const parseLocation: LocationParser = (
	query,
	result,
): ParsedLocation => {
	const coordinates: google.maps.LatLng | undefined =
		result?.geometry?.location;

	function getCoordinate(coordinate: string): number {
		if (coordinates?.[coordinate] == null) {
			return 0;
		}

		if (isFunction(coordinates[coordinate])) {
			return coordinates[coordinate]();
		}

		return coordinates[coordinate];
	}

	return {
		lat: getCoordinate('lat'),
		lng: getCoordinate('lng'),
	};
};

const getCity = (
	addressComponent: google.maps.GeocoderAddressComponent,
): string => {
	const types = addressComponent.types ?? [];

	if (
		!types.includes('locality') &&
		!types.includes('sublocality') &&
		!types.includes('administrative_area_level_3')
	) {
		return '';
	}

	return addressComponent.long_name;
};

export const parseAddress: LocationParser = (query, result): Location => {
	const addressComponents = result.address_components ?? [];

	let city = '';
	let state = '';
	let country = '';
	let zipcode = '';
	let county = '';

	for (const addressComponent of addressComponents) {
		const { types } = addressComponent;

		city = city || getCity(addressComponent);

		if (types.includes('administrative_area_level_1')) {
			state = addressComponent.short_name;
		}

		if (types.includes('country')) {
			country = addressComponent.short_name;
		}

		if (types.includes('postal_code')) {
			zipcode = addressComponent.short_name;
		}

		if (types.includes('administrative_area_level_2')) {
			county = addressComponent.short_name;
		}
	}

	return { city, state, country, zipcode, county };
};

export const DEFAULT_PARSERS: LocationParser[] = [parseAddress, parseLocation];
